import ReactOptinSettings from 'owa-service/lib/contract/ReactOptinSettings';
import { getUserConfiguration } from 'owa-session-store';

/**
 * Returns true if react calendar is flighted for the user
 */
export function isReactCalendarEnabled() {
    const optinSettings = getReactOptinSettings();
    return !!(optinSettings && optinSettings.CalendarMobileEnabled);
}

/**
 * Returns the react optin settings of the user
 */
function getReactOptinSettings(): ReactOptinSettings {
    const userConfiguration = getUserConfiguration();
    return (
        userConfiguration &&
        userConfiguration.UserOptions &&
        userConfiguration.UserOptions.ReactOptinSettings
    );
}
